module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/something_went_wrong.5cd538af5182c6d15b8d836e00fa1b2c.svg";